const DIACRITICS = /[̀-ͯ]/g;

export const toCategoryQueryValue = (chipText: string): string =>
    chipText
        .normalize('NFD')
        .replace(DIACRITICS, '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-');
